<div
  class="card m-b-10 base-shadow-list b-0"
  *ngIf="getIsRespondentsApprovalExists(processRespondentsApproval$ | async)"
>
  <app-respondents-approval-search-page-header
    (searchRequestLoaded)="setSearchRequest($event, processRespondentsApproval)"
    (approveClicked)="approve()"
    (getAppraisee)="getEmployee($event)"
    [processRespondentsApproval]="processRespondentsApproval"
  ></app-respondents-approval-search-page-header>
  <div class="card-body" *ngIf="appraisee">
    <div class="row p-t-20 p-b-20 add-by-category">
      <div class="col-12 d-flex justify-content-start">
        <div *ngFor="let processRespondentApproval of processRespondentsApproval">
          <div class="d-flex m-l-25">
            <div>
              <div class="caption">
                {{ getSelectionColumnName(processRespondentApproval.selectionCriterionType) | async }}
              </div>
              <div
                [tooltip]="'lang.approval.notEnoughRespondents' | translate"
                [isOpen]="canShowError(processRespondentApproval)"
                triggers=""
                placement="bottom"
                container="body"
                containerClass="error-tooltip"
                #pop="bs-tooltip"
              >
                <span
                  class="respondents-ammount"
                  [ngStyle]="{
                    color: hasEnoughRespondents(processRespondentApproval) ? 'black' : '#c4087e'
                  }"
                >
                  {{ processRespondentApproval.respondents.length }}
                </span>
                {{ 'lang.common.of' | translate }}
                <span class="respondents-ammount">{{ getApprovalvalue(processRespondentApproval) }}</span>
              </div>
            </div>
            <div class="m-l-10">
              <span class="add-btn-white" (click)="navigateToRespondentsApproval(processRespondentApproval)"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ml-3 mr-3" *ngIf="processRespondentsApproval && getIsAnyRespondents()">
      <div class="row">
        <div class="col-12 block-search">
          {{ 'lang.common.respondents' | translate }}
        </div>
      </div>
      <div>
        <div *ngFor="let processRespondentApproval of processRespondentsApproval">
          <div
            *ngFor="let respondent of sortByRespondent(processRespondentApproval.respondents)"
            class="row p-t-10 p-b-10 br-respondent"
          >
            <div class="col-4 pl-0 pr-0">
              <app-user-avatar [employeeId]="respondent.id"></app-user-avatar>
              <div class="float-left">
                <div class="font-weight-bold">
                  {{ respondent.displayName }}
                </div>
                <div>
                  {{ respondent.position.name }}
                </div>
              </div>
            </div>
            <div class="col-3 pr-0">
              {{ respondent.businessUnitDisplayName }}
            </div>
            <div class="col-2 pr-0 text-center">
              {{ respondent.grade.name }}
            </div>
            <div class="col-2 pr-0">
              {{ getSelectionColumnName(processRespondentApproval.selectionCriterionType) | async }}
            </div>
            <div class="col-1 pr-0 text-right">
              <i
                (click)="deleteRespondent(respondent, processRespondentApproval.selectionCriterionType)"
                class="ti-close"
              ></i>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 pl-0 pr-0 text-right">
            <button
              class="m-b-10 m-t-10 btn-confirm-appraisee"
              (click)="tryApprove(approveModal)"
              [disabled]="approveDisabled"
            >
              {{ 'lang.common.btn.approve' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #approveModal>
  <div>
    <div class="modal-body">
      <h4>{{ 'lang.common.warning.approveTitle' | translate }}</h4>
      <div class="modal-content d-flex justify-content-center flex-column">
        <div>
          {{ 'lang.common.warning.approveMessage' | translate }}
        </div>
      </div>
      <div class="btn-modal">
        <span (click)="modalRef.hide()"> {{ 'lang.common.btn.cancel' | translate }} </span>
        <span (click)="approve()">{{ 'lang.common.btn.approve' | translate }}</span>
      </div>
    </div>
  </div>
</ng-template>
